import React, { useState } from "react";
import { Row, Col, Button, Spinner } from "react-bootstrap";
// import {
//     getDiscountNumbers,
//     getNumbersByPrice
// } from "../../services/numberService";

import CardItem from "../Card/CardItem";
import "./TabCards.css";

const defaultLimits = {
    All: 100,
    Discount: 50,
    "1000": 50,
    "2000": 50,
    "3000": 50,
    "5000": 50,
    "6000": 50,
    "7500": 50,
    "10000": 50
};

const TabCards = ({ filterState, allNumbers, loading, error }) => {
    const [viewMoreMap, setViewMoreMap] = useState({});
    const [viewMoreLoadingMap, setViewMoreLoadingMap] = useState({});

    const getPrice = (priceStr) => {
        if (!priceStr) return 0;
        return parseFloat(priceStr.toString().replace(/,/g, ''));
    };

    const isMatchCategory = (price, category) => {
        if (!category) return true;
        switch(category) {
            case 'Bronze': return price < 10000;
            case 'Silver': return price >= 10000 && price < 25000;
            case 'Gold': return price >= 25000 && price < 50000;
            case 'Platinum': return price >= 50000 && price < 100000;
            case 'VIP': return price >= 100000;
            default: return true;
        }
    };

    if (loading) return <p className="text-center mt-5">Loading...</p>;
    if (error) return <p className="text-center text-danger mt-5">{error}</p>;

    let currentCardsAll = allNumbers || [];
    
    // Apply filters
    if (filterState) {
        currentCardsAll = currentCardsAll.filter(card => {
            const networkMatches = filterState.network ? 
                card.network?.toLowerCase() === filterState.network.toLowerCase() : true;
            
            const price = getPrice(card.sell_price);
            const categoryMatches = isMatchCategory(price, filterState.category);

            return networkMatches && categoryMatches;
        });
    }

    const currentLimit = defaultLimits["All"] || 100;
    const isShowingAll = viewMoreMap["All"];
    const currentCards = isShowingAll ? currentCardsAll : currentCardsAll.slice(0, currentLimit);

    return (
        <section id="cardSection" className="mb-5">

            <div className="container-fluid px-3 px-md-5 text-center">

                {loading && (
                    <div className="text-center py-5">
                        <Spinner animation="border" variant="danger" />
                    </div>
                )}

                            <Row xs={1} md={2} xl={4} className="g-4">
                                {currentCards.length > 0 ? (
                                    currentCards.map((card, index) => (
                                        <Col key={index}>
                                                <CardItem
                                                formatted_number={card.formatted_number}
                                                network={card.network}
                                                tag={card.tag}
                                                sell_price={card.sell_price}
                                            />
                                        </Col>
                                    ))
                                ) : (
                                    <p className="text-center text-muted w-100">
                                        No numbers available.
                                    </p>
                                )}
                            </Row>

                {(!isShowingAll && currentCardsAll.length > currentLimit) && (
                    <div className="mt-4">
                        <Button
                            className="view-more-btn"
                            disabled={viewMoreLoadingMap["All"]}
                            onClick={() => {
                                setViewMoreLoadingMap(prev => ({ ...prev, "All": true }));
                                setTimeout(() => {
                                    setViewMoreMap(prev => ({ ...prev, "All": true }));
                                    setViewMoreLoadingMap(prev => ({ ...prev, "All": false }));
                                }, 500);
                            }}
                        >
                            {viewMoreLoadingMap["All"] ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                        variant="danger"
                                    />
                                    Loading...
                                </>
                            ) : (
                                "View More"
                            )}
                        </Button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default TabCards;
